import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import EllipsisIcon from '../../../Icons/Ellipsis';
import { IconSize } from '../../../Icons/IconWrap';
import IconLayout from '../IconLayout';
import PopoverWithTooltip from '../PopoverWithTooltip';
import MoreMenuContent from './MoreMenuContent';
import s from './MoreMenu.scss';
export var MoreMenu = function (_a) {
    var deviation = _a.deviation, _b = _a.size, size = _b === void 0 ? IconSize.MEDIUM : _b, className = _a.className;
    var t = useTranslation().t;
    return (React.createElement(IconLayout, { title: t('actionbar.more') },
        React.createElement(PopoverWithTooltip, { allowMobile: true, renderPopover: function (_a) {
                var closeTooltip = _a.closeTooltip;
                return (React.createElement(MoreMenuContent, { deviation: deviation, closeTooltip: closeTooltip }));
            }, wrapperClassName: classnames(s['root'], className), tooltip: t('actionbar.more.tooltip'), showArrow: false, positionOnly: true },
            React.createElement(EllipsisIcon, { size: size }))));
};
MoreMenu.displayName = 'MoreMenu';
export default MoreMenu;
//# sourceMappingURL=MoreMenu.js.map